import React from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";

import { teachersData } from "../../topTeachers/utils/teachersData";

import classes from "./LeftSide.module.css";

const LeftSide = () => {
  const { t } = useTranslation();

  return (
    <div data-aos="fade-up" className={classes["wrapper"]}>
      <p className={classes["title"]}>
        {t("We are developing your future.")} <span>{t("Join us.")}</span>
      </p>
      <div className={classes["count-up"]}>
        <div className={classes["item"]}>
          <p className={classes["number"]}>
            <CountUp end={teachersData.length} duration={7} />+
          </p>
          <h4 className={classes["text"]}>{t("Teachers")}</h4>
        </div>
        <div className={classes["item"]}>
          <p className={classes["number"]}>
            <CountUp end={2000} duration={7} />+
          </p>
          <h4 className={classes["text"]}>{t("Students")}</h4>
        </div>
      </div>
    </div>
  );
};

export default LeftSide;
